export const bankInfo = [
  {
    number: "1",
    Name: "AGRA DISTRICT CENTRAL CO-OPERATIVE BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "2",
    Name: "Agriwise Finserv Ltd",
    Type: "Non-Banking Financial Companies",
    "Intrest Rate(%)": "9",
  },
  {
    number: "3",
    Name: "AJMER CENTRAL CO-OPERATIVE BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "4",
    Name: "AKOLA DISTRICT CENTRAL CO-OPERATIVE BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "5",
    Name: "ALIGARH JILA SAHKARI BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "6",
    Name: "ALLAHABAD DISTRICT CO-OPERATIVE BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "7",
    Name: "ALMORA ZILLA SAHAKARI BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "8",
    Name: "AMRAWATI DISTRICT CENTRAL CO-OPERATIVE BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "9",
    Name: "Andhra Pradesh Grameena Vikas Bank",
    Type: "Regional Rural Banks",
    "Intrest Rate(%)": "9",
  },
  {
    number: "10",
    Name: "Andhra Pragathi Grameena Bank",
    Type: "Regional Rural Banks",
    "Intrest Rate(%)": "9",
  },
  {
    number: "11",
    Name: "Aryavart Bank",
    Type: "Regional Rural Banks",
    "Intrest Rate(%)": "9",
  },
  {
    number: "12",
    Name: "Assam Gramin Vikash Bank",
    Type: "Regional Rural Banks",
    "Intrest Rate(%)": "9",
  },
  {
    number: "13",
    Name: "AU Small Finance Bank Limited",
    Type: "Small Finance Banks",
    "Intrest Rate(%)": "9",
  },
  {
    number: "14",
    Name: "AURANGABAD DISTRICT CENTRAL CO-OPERATIVE BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "15",
    Name: "Axis Bank",
    Type: "Scheduled Commercial Banks",
    "Intrest Rate(%)": "9",
  },
  {
    number: "16",
    Name: "BAGALKOT DISTRICT CENTRAL CO-OPERATIVE BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "17",
    Name: "BAHRICH DISTRICT CO-OPERATIVE BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "18",
    Name: "BALAGERIA CENTRAL CO-OPERATIVE BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "19",
    Name: "BANASKANTHA DISTRICT CENTRAL CO-OPERATIVE BANK",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "20",
    Name: "BANDA DISTRICT CO-OPERATIVE BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "21",
    Name: "Bandhan Bank Ltd",
    Type: "Scheduled Commercial Banks",
    "Intrest Rate(%)": "9",
  },
  {
    number: "22",
    Name: "Bangiya Gramin Vikash Bank",
    Type: "Regional Rural Banks",
    "Intrest Rate(%)": "9",
  },
  {
    number: "23",
    Name: "Bank Of Baroda",
    Type: "Scheduled Commercial Banks",
    "Intrest Rate(%)": "8.6",
  },
  {
    number: "24",
    Name: "Bank Of India",
    Type: "Scheduled Commercial Banks",
    "Intrest Rate(%)": "9",
  },
  {
    number: "25",
    Name: "Bank of Maharashtra",
    Type: "Scheduled Commercial Banks",
    "Intrest Rate(%)": "9",
  },
  {
    number: "26",
    Name: "BANKURA DIST CENTRAL CO-OPERATIVE BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "27",
    Name: "BARAMULLA CENTRAL CO-OPERATIVE BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "28",
    Name: "BARAN KENDRIYA SAHAKARI BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "29",
    Name: "Baroda Gujarat Gramin Bank",
    Type: "Regional Rural Banks",
    "Intrest Rate(%)": "9",
  },
  {
    number: "30",
    Name: "Baroda Rajasthan Kshetriya Gramin Bank",
    Type: "Regional Rural Banks",
    "Intrest Rate(%)": "9",
  },
  {
    number: "31",
    Name: "Baroda UP Bank",
    Type: "Regional Rural Banks",
    "Intrest Rate(%)": "9",
  },
  {
    number: "32",
    Name: "BEED DISTRICT CENTRAL CO-OPERATIVE BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "33",
    Name: "BHANDARA DISTRICT CENTRAL CO-OPERATIVE BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "34",
    Name: "BHAVNAGAR DISTRICT CO-OPERATIVE BANK LTD",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "35",
    Name: "BHOPAL CO-OPERATIVE CENTRAL BANK LTD., BHOPAL",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "36",
    Name: "BIJNOR JILLA SAHKARI BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "37",
    Name: "BIRBHUM DISTRICT CENTRAL CO-OPERATIVE BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "38",
    Name: "BUDAUN JILLA SAHKARI BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "39",
    Name: "BULDHANA DISTRICT CENTRAL CO-OPERATIVE BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "40",
    Name: "Canara Bank",
    Type: "Scheduled Commercial Banks",
    "Intrest Rate(%)": "8.45",
  },
  {
    number: "41",
    Name: "CAPITAL SMALL FINANCE BANK Ltd.",
    Type: "Small Finance Banks",
    "Intrest Rate(%)": "9",
  },
  {
    number: "42",
    Name: "Central Bank Of India",
    Type: "Scheduled Commercial Banks",
    "Intrest Rate(%)": "8.8",
  },
  {
    number: "43",
    Name: "CENTRAL CO-OPERATIVE BANK LTD., ARA",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "44",
    Name: "Chaitanya Godavari Grameena Bank",
    Type: "Regional Rural Banks",
    "Intrest Rate(%)": "9",
  },
  {
    number: "45",
    Name: "CHAMOLI ZILLA SAHAKARI BANK LTD., CHAMOLI",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "46",
    Name: "CHANDRAPUR DISTRICT CENTRAL CO-OPERATIVE BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "47",
    Name: "CHENNAI CENTRAL CO-OPERATIVE BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "48",
    Name: "Chhattishgarh Rajya Gramin Bank",
    Type: "Regional Rural Banks",
    "Intrest Rate(%)": "9",
  },
  {
    number: "49",
    Name: "CHITTORGARH KENDRIYA SAHAKARI BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "50",
    Name: "City Union Bank",
    Type: "Scheduled Commercial Banks",
    "Intrest Rate(%)": "9",
  },
  {
    number: "51",
    Name: "CSB Bank Ltd",
    Type: "Scheduled Commercial Banks",
    "Intrest Rate(%)": "9",
  },
  {
    number: "52",
    Name: "CUTTACK CENTRAL CO-OPERATIVE BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "53",
    Name: "Dakshin Bihar Gramin Bank",
    Type: "Regional Rural Banks",
    "Intrest Rate(%)": "9",
  },
  {
    number: "54",
    Name: "DARJEELING DISTRICT CENTRAL CO-OPERATIVE BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "55",
    Name: "DAUSA KENDRIYA SAHAKARI BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "56",
    Name: "DCB Bank",
    Type: "Scheduled Commercial Banks",
    "Intrest Rate(%)": "9",
  },
  {
    number: "57",
    Name: "DCCB_Khammam",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "58",
    Name: "DEORIA KASIA CO-OPERATIVE BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "59",
    Name: "Dhanlaxmi Bank Ltd",
    Type: "Scheduled Commercial Banks",
    "Intrest Rate(%)": "9",
  },
  {
    number: "60",
    Name: "DHULE & NANDURBAR DISTRICT CENTRAL CO-OPERATIVEBANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "61",
    Name: "DINDIGUL CENTRAL CO-OPERATIVE BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "62",
    Name: "DISTRICT CENTRAL CO-OPERATIVE BANK LTD., BILASPUR",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "63",
    Name: "DISTRICT CENTRAL CO-OPERATIVE BANK LTD., DURG",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "64",
    Name: "DISTRICT CENTRAL CO-OPERATIVE BANK LTD., SUPAUL",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "65",
    Name: "DISTRICT CO-OPERATIVE BANK LTD.,  SAHARANPUR",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "66",
    Name: "DISTRICT CO-OPERATIVE BANK LTD., VARANASI",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "67",
    Name: "DISTRICT COOPERATIVE BANK LTD., DEHRADUN",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "68",
    Name: "ESAF Small Finance Bank Limited",
    Type: "Small Finance Banks",
    "Intrest Rate(%)": "9",
  },
  {
    number: "69",
    Name: "ETAH DISTRICT CO-OPERATIVE BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "70",
    Name: "ETAWAH JILLA SAHKARI BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "71",
    Name: "FAIZABAD JILLA SAHKARI BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "72",
    Name: "FARRUKHABAD DISTRICT CO-OPERATIVE BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "73",
    Name: "FATEHPUR DISTRICT CO-OPERATIVE BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "74",
    Name: "FIROZABAD JILLA SAHKARI BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "75",
    Name: "GADCHIROLI DISTRICT CENTRAL CO-OPERATIVE BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "76",
    Name: "GHAZIABAD JILLA SAHKARI BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "77",
    Name: "GORAKHPUR JILLA SAHKARI BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "78",
    Name: "HAMIRPUR DISTRICT CO-OPERATIVE BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "79",
    Name: "HANUMANGARH KENDRIYA SAHAKARI BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "80",
    Name: "HARDOI JILLA SAHKARI BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "81",
    Name: "HDFC Bank",
    Type: "Scheduled Commercial Banks",
    "Intrest Rate(%)": "9",
  },
  {
    number: "82",
    Name: "Himachal Pradesh Gramin Bank",
    Type: "Regional Rural Banks",
    "Intrest Rate(%)": "9",
  },
  {
    number: "83",
    Name: "HOOGHLY DISTRICT CENTRAL CO-OPERATIVE BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "84",
    Name: "HOWRAH DISTRICT CENTRAL CO-OPERATIVE BANK LTD",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "85",
    Name: "ICICI Bank",
    Type: "Scheduled Commercial Banks",
    "Intrest Rate(%)": "9",
  },
  {
    number: "86",
    Name: "IDBI BANK LTD",
    Type: "Scheduled Commercial Banks",
    "Intrest Rate(%)": "9",
  },
  {
    number: "87",
    Name: "IDFC FIRST Bank Ltd.",
    Type: "Scheduled Commercial Banks",
    "Intrest Rate(%)": "9",
  },
  {
    number: "88",
    Name: "Indian Bank",
    Type: "Scheduled Commercial Banks",
    "Intrest Rate(%)": "9",
  },
  {
    number: "89",
    Name: "Indian Overseas Bank",
    Type: "Scheduled Commercial Banks",
    "Intrest Rate(%)": "8.65",
  },
  {
    number: "90",
    Name: "INDORE PREMIER CO-OPERATIVE BANK LIMITED, INDORE",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "91",
    Name: "IndusInd Bank",
    Type: "Scheduled Commercial Banks",
    "Intrest Rate(%)": "9",
  },
  {
    number: "92",
    Name: "J&K Bank",
    Type: "Scheduled Commercial Banks",
    "Intrest Rate(%)": "9",
  },
  {
    number: "93",
    Name: "JALAUN DISTRICT  CO-OERATIVE BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "94",
    Name: "Jalgaon Janata Sahakari Bank Ltd.",
    Type: "Scheduled Cooperative Banks",
    "Intrest Rate(%)": "9",
  },
  {
    number: "95",
    Name: "JALNA DISTRICT CENTRAL CO-OPERATIVE BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "96",
    Name: "Janta Sahkari Bank",
    Type: "Scheduled Cooperative Banks",
    "Intrest Rate(%)": "9",
  },
  {
    number: "97",
    Name: "Jharkhand Rajya Gramin Bank",
    Type: "Regional Rural Banks",
    "Intrest Rate(%)": "9",
  },
  {
    number: "98",
    Name: "JHUNJHUNU KENDRIYA SAHAKARI BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "99",
    Name: "JILA SAHAKARI BANK LTD., MAU",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "100",
    Name: "JILA SAHAKARI KENDRIYA BANK MARYADIT, AMBIKAPUR",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "101",
    Name: "JILA SAHAKARI KENDRIYA BANK MARYADIT, JAGDALPUR",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "102",
    Name: "JILA SAHAKARI KENDRIYA BANK MARYADIT, RAIPUR",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "103",
    Name: "JILLA SAHAKARI BANK LTD., AZAMGARH",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "104",
    Name: "JILLA SAHAKARI BANK LTD., GHAZIPUR",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "105",
    Name: "JILLA SAHAKARI KENDRIYA BANK MARYADIT, BALAGHAT",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "106",
    Name: "JILLA SAHAKARI KENDRIYA BANK MARYADIT, BETUL",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "107",
    Name: "JILLA SAHAKARI KENDRIYA BANK MARYADIT, BHIND",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "108",
    Name: "JILLA SAHAKARI KENDRIYA BANK MARYADIT, CHATTARPUR",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "109",
    Name: "JILLA SAHAKARI KENDRIYA BANK MARYADIT, CHHINDWARA",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "110",
    Name: "JILLA SAHAKARI KENDRIYA BANK MARYADIT, DAMOH",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "111",
    Name: "JILLA SAHAKARI KENDRIYA BANK MARYADIT, DATIA",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "112",
    Name: "JILLA SAHAKARI KENDRIYA BANK MARYADIT, DEWAS",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "113",
    Name: "JILLA SAHAKARI KENDRIYA BANK MARYADIT, DHAR",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "114",
    Name: "JILLA SAHAKARI KENDRIYA BANK MARYADIT, GUNA",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "115",
    Name: "JILLA SAHAKARI KENDRIYA BANK MARYADIT, GWALIOR",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "116",
    Name: "JILLA SAHAKARI KENDRIYA BANK MARYADIT, HOSHANGABAD",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "117",
    Name: "JILLA SAHAKARI KENDRIYA BANK MARYADIT, JABALPUR",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "118",
    Name: "JILLA SAHAKARI KENDRIYA BANK MARYADIT, JHABUA",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "119",
    Name: "JILLA SAHAKARI KENDRIYA BANK MARYADIT, KHANDWA",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "120",
    Name: "JILLA SAHAKARI KENDRIYA BANK MARYADIT, KHARGONE",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "121",
    Name: "JILLA SAHAKARI KENDRIYA BANK MARYADIT, MANDLA",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "122",
    Name: "JILLA SAHAKARI KENDRIYA BANK MARYADIT, MANDSAUR",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "123",
    Name: "JILLA SAHAKARI KENDRIYA BANK MARYADIT, MORENA",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "124",
    Name: "JILLA SAHAKARI KENDRIYA BANK MARYADIT, NARSINGHPUR",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "125",
    Name: "JILLA SAHAKARI KENDRIYA BANK MARYADIT, PANNA",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "126",
    Name: "JILLA SAHAKARI KENDRIYA BANK MARYADIT, RAISEN",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "127",
    Name: "JILLA SAHAKARI KENDRIYA BANK MARYADIT, RAJGARH",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "128",
    Name: "JILLA SAHAKARI KENDRIYA BANK MARYADIT, RATLAM",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "129",
    Name: "JILLA SAHAKARI KENDRIYA BANK MARYADIT, REWA",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "130",
    Name: "JILLA SAHAKARI KENDRIYA BANK MARYADIT, SAGAR",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "131",
    Name: "JILLA SAHAKARI KENDRIYA BANK MARYADIT, SATNA",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "132",
    Name: "JILLA SAHAKARI KENDRIYA BANK MARYADIT, SEHORE",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "133",
    Name: "JILLA SAHAKARI KENDRIYA BANK MARYADIT, SEONI",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "134",
    Name: "JILLA SAHAKARI KENDRIYA BANK MARYADIT, SHAHDOL",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "135",
    Name: "JILLA SAHAKARI KENDRIYA BANK MARYADIT, SHAJAPUR",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "136",
    Name: "JILLA SAHAKARI KENDRIYA BANK MARYADIT, SHIVPURI",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "137",
    Name: "JILLA SAHAKARI KENDRIYA BANK MARYADIT, SIDHI",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "138",
    Name: "JILLA SAHAKARI KENDRIYA BANK MARYADIT, TIKAMGARH",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "139",
    Name: "JILLA SAHAKARI KENDRIYA BANK MARYADIT, UJJAIN",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "140",
    Name: "JILLA SAHAKARI KENDRIYA BANK MARYADIT, VIDISHA",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "141",
    Name: "JILLA SAHKARI  BANK LTD., BARABANKI",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "142",
    Name: "JILLA SAHKARI BANK LTD., BALLIA",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "143",
    Name: "JILLA SAHKARI BANK LTD., BAREILLY",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "144",
    Name: "JILLA SAHKARI BANK LTD., BASTI",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "145",
    Name: "JILLA SAHKARI BANK LTD., BULANDSAHAR",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "146",
    Name: "JILLA SAHKARI BANK LTD., JAUNPUR",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "147",
    Name: "JILLA SAHKARI BANK LTD., JHANSI",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "148",
    Name: "JILLA SAHKARI BANK LTD., KANPUR",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "149",
    Name: "JILLA SAHKARI BANK LTD., LAKHIMPUR-KHIRI",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "150",
    Name: "JILLA SAHKARI BANK LTD., LALITPUR",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "151",
    Name: "JILLA SAHKARI BANK LTD., LUCKNOW.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "152",
    Name: "JILLA SAHKARI BANK LTD., MEERUT",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "153",
    Name: "JILLA SAHKARI BANK LTD., MIRZAPUR",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "154",
    Name: "JILLA SAHKARI BANK LTD., MURADABAD",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "155",
    Name: "JILLA SAHKARI BANK LTD., PRATAPGARH",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "156",
    Name: "JILLA SAHKARI BANK LTD., RAIBAREILLY",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "157",
    Name: "JILLA SAHKARI BANK LTD., SHAHJAHANPUR",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "158",
    Name: "JILLA SAHKARI BANK LTD., SIDHARTHNAGAR",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "159",
    Name: "JILLA SAHKARI BANK LTD., SITAPUR",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "160",
    Name: "JILLA SAHKARI BANK LTD., UNNAO",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "3",
  },
  {
    number: "161",
    Name: "JOGINDRA CENTRAL CO-OPERATIVE BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "162",
    Name: "John Deere Financial India Private Limited",
    Type: "Non-Banking Financial Companies",
    "Intrest Rate(%)": "9",
  },
  {
    number: "163",
    Name: "Karnataka Bank",
    Type: "Scheduled Commercial Banks",
    "Intrest Rate(%)": "8.95",
  },
  {
    number: "164",
    Name: "Karnataka Gramin Bank",
    Type: "Regional Rural Banks",
    "Intrest Rate(%)": "9",
  },
  {
    number: "165",
    Name: "KARNATAKA VIKAS GRAMEEN BANK",
    Type: "Regional Rural Banks",
    "Intrest Rate(%)": "9",
  },
  {
    number: "166",
    Name: "Karur Vysya Bank",
    Type: "Scheduled Commercial Banks",
    "Intrest Rate(%)": "9",
  },
  {
    number: "167",
    Name: "KEONJHAR CENTRAL CO-OPERATIVE BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "168",
    Name: "Kerala Gramin Bank",
    Type: "Regional Rural Banks",
    "Intrest Rate(%)": "9",
  },
  {
    number: "169",
    Name: "Kerala State Cooperative Bank - CPC -Thrissur",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "170",
    Name: "Kerala State Cooperative Bank - CPC -Wayanad",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "171",
    Name: "Kerala State Cooperative Bank - CPC- Idukki",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "172",
    Name: "Kerala State Cooperative Bank - CPC- Kannur",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "173",
    Name: "Kerala State Cooperative Bank - CPC- Kasaragod",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "174",
    Name: "Kerala State Cooperative Bank - CPC- Kottayam",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "175",
    Name: "Kerala State Cooperative Bank - CPC- Kozhikode",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "176",
    Name: "Kerala State Cooperative Bank - CPC- Palakkad",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "177",
    Name: "Kerala State Cooperative Bank -CPC -Ernakulam",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "178",
    Name: "Kerala State Cooperative Bank -CPC- Alappuzha",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "179",
    Name: "Kerala State Cooperative Bank -CPC-Kollam (DCCB-Branch)",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "180",
    Name: "Kerala State Cooperative Bank -CPC-Pathanamathitta",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "181",
    Name: "Kerala State Corporative Bank- Non PACS",
    Type: "Scheduled Commercial Banks",
    "Intrest Rate(%)": "9",
  },
  {
    number: "182",
    Name: "KOLHAPUR DISTRICT CENTRAL CO-OPERATIVE BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "183",
    Name: "Kotak Mahindra Bank",
    Type: "Scheduled Commercial Banks",
    "Intrest Rate(%)": "9",
  },
  {
    number: "184",
    Name: "LATUR DISTRICT CENTRAL CO-OPERATIVE BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "9",
  },
  {
    number: "185",
    Name: "Madhya Pradesh Gramin Bank",
    Type: "Regional Rural Banks",
    "Intrest Rate(%)": "9",
  },
  {
    number: "186",
    Name: "Madhyanchal Gramin Bank",
    Type: "Regional Rural Banks",
    "Intrest Rate(%)": "9",
  },
  {
    number: "187",
    Name: "Maharashtra Gramin Bank",
    Type: "Regional Rural Banks",
    "Intrest Rate(%)": "9",
  },
  {
    number: "188",
    Name: "Mahindra and Mahindra Financial Services Ltd.",
    Type: "Non-Banking Financial Companies",
    "Intrest Rate(%)": "9",
  },
  {
    number: "189",
    Name: "MAINPURI JILLA SAHKARI BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "190",
    Name: "MALDA DISTRICT CENTRAL CO-OPERATIVE BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "191",
    Name: "MANDYA DISTRICT  CO-OPERATIVE  CENTRAL BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "192",
    Name: "MATHURA JILLA SAHKARI BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "193",
    Name: "MEHSANA DISTRICT CENTRAL CO-OPERATIVE BANK",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "194",
    Name: "Mizoram Cooperative Apex Bank",
    Type: "State Cooperative Banks",
    "Intrest Rate(%)": "4",
  },
  {
    number: "195",
    Name: "Mizoram Rural Bank",
    Type: "Regional Rural Banks",
    "Intrest Rate(%)": "9",
  },
  {
    number: "196",
    Name: "Mugberia Central Co-operative Bank Limited",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "197",
    Name: "MURSHIDABAD DISTRICT CENTRAL CO-OPERATIVE BANK LTD",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "198",
    Name: "MUZAFFARNAGAR DISTRICT CO-OPERATIVE BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "199",
    Name: "NABKISAN Finance Ltd",
    Type: "Non-Banking Financial Companies",
    "Intrest Rate(%)": "9",
  },
  {
    number: "200",
    Name: "NADIA DISTRICT CENTRAL CO-OPERATIVE BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "201",
    Name: "Nagaland Rural Bank",
    Type: "Regional Rural Banks",
    "Intrest Rate(%)": "9",
  },
  {
    number: "202",
    Name: "NAGPUR DISTRICT CENTRAL CO-OPERATIVE BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "203",
    Name: "Nagpur Nagarik Sahakari Bank Ltd.",
    Type: "Multi State Scheduled Cooperative Banks",
    "Intrest Rate(%)": "9",
  },
  {
    number: "204",
    Name: "Nainital Bank",
    Type: "Scheduled Commercial Banks",
    "Intrest Rate(%)": "9",
  },
  {
    number: "205",
    Name: "NAINITAL DISTRICT CO-OPERATIVE BANK LTD., HALDWANI",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "206",
    Name: "NASIK DISTRICT CENTRAL CO-OPERATIVE BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "207",
    Name: "National Cooperative Development Corporation (NCDC)",
    Type: "National Cooperative Development Corporation",
    "Intrest Rate(%)": "9",
  },
  {
    number: "208",
    Name: "NAYAGARH DISTRICT CENTRAL CO-OPERATIVE BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "209",
    Name: "NKGSB Cooperative Bank Ltd",
    Type: "Multi State Scheduled Cooperative Banks",
    "Intrest Rate(%)": "9",
  },
  {
    number: "210",
    Name: "North Eastern Development Finance Corporation",
    Type: "Non-Banking Financial Companies",
    "Intrest Rate(%)": "9",
  },
  {
    number: "211",
    Name: "ODISHA GRAMYA BANK",
    Type: "Regional Rural Banks",
    "Intrest Rate(%)": "9",
  },
  {
    number: "212",
    Name: "OSMANABAD DISTRICT CENTRAL CO-OPERATIVE BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "213",
    Name: "PANCHMAHALS DISTRICT CO-OPERATIVE BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "214",
    Name: "PARBHANI DISTRICT CENTRAL CO-OPERATIVE BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "215",
    Name: "Paschim Banga Gramin Bank",
    Type: "Regional Rural Banks",
    "Intrest Rate(%)": "9",
  },
  {
    number: "216",
    Name: "PILIBHIT JILLA SAHKARI BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "217",
    Name: "PITHORAGARH ZILA SAHAKARI BANK LTD., PITHORAGARH",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "218",
    Name: "Prathama UP Gramin Bank",
    Type: "Regional Rural Banks",
    "Intrest Rate(%)": "9",
  },
  {
    number: "219",
    Name: "PUNE DISTRICT CENTRAL CO-OPERATIVE BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "220",
    Name: "Punjab and Sind Bank",
    Type: "Scheduled Commercial Banks",
    "Intrest Rate(%)": "8.8",
  },
  {
    number: "221",
    Name: "Punjab Gramin Bank_RRB",
    Type: "Regional Rural Banks",
    "Intrest Rate(%)": "9",
  },
  {
    number: "222",
    Name: "Punjab National Bank",
    Type: "Scheduled Commercial Banks",
    "Intrest Rate(%)": "8",
  },
  {
    number: "223",
    Name: "PURULIA DISTRICT CENTRAL CO-OPERATIVE BANK LTD",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "224",
    Name: "RAIGAD DISTRICT CENTRAL CO-OPERATIVE BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "225",
    Name: "Raiganj Central Co-operative Bank Ltd.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "226",
    Name: "Rajasthan Marudhara Gramin Bank",
    Type: "Regional Rural Banks",
    "Intrest Rate(%)": "9",
  },
  {
    number: "227",
    Name: "Rajasthan Marudhara Gramin Bank (RMGB), Jodhpur",
    Type: "Regional Rural Banks",
    "Intrest Rate(%)": "9",
  },
  {
    number: "228",
    Name: "RAJKOT DISTRICT CO-OPERATIVE  BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "229",
    Name: "RAJNANDGAON KENDRIYA SAHAKARI BANK MARYADIT, RAJNANDGAON",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "230",
    Name: "RAMPUR JILLA SAHKARI BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "231",
    Name: "RATNAGIRI DISTRICT CENTRAL CO-OPERATIVE BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "232",
    Name: "RBL Bank Ltd.",
    Type: "Scheduled Commercial Banks",
    "Intrest Rate(%)": "9",
  },
  {
    number: "233",
    Name: "SABARKANTHA DISTRICT CENTRAL CO-OPERATIVE BANK",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "234",
    Name: "Samunnati Financial Intermediation & Services Private Limited",
    Type: "Non-Banking Financial Companies",
    "Intrest Rate(%)": "9",
  },
  {
    number: "235",
    Name: "SANGLI DISTRICT CENTRAL CO-OPERATIVE BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "236",
    Name: "Sangli Urban Co-Operative Bank Ltd.",
    Type: "Scheduled Cooperative Banks",
    "Intrest Rate(%)": "9",
  },
  {
    number: "237",
    Name: "Saptagiri Grameena Bank",
    Type: "Regional Rural Banks",
    "Intrest Rate(%)": "9",
  },
  {
    number: "238",
    Name: "Sarva Haryana Gramin Bank",
    Type: "Regional Rural Banks",
    "Intrest Rate(%)": "9",
  },
  {
    number: "239",
    Name: "SASARAM-BHABUA CENTRAL CO-OPERATIVE BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "240",
    Name: "Saurashtra Gramin Bank",
    Type: "Regional Rural Banks",
    "Intrest Rate(%)": "9",
  },
  {
    number: "241",
    Name: "SAWAI MADHOPUR KENDRIYA SAHAKARI BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "242",
    Name: "Shivalik Small Finance Bank Limited",
    Type: "Small Finance Banks",
    "Intrest Rate(%)": "9",
  },
  {
    number: "243",
    Name: "SINDHUDURG DISTRICT CENTRAL CO-OPERATIVE BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "244",
    Name: "SOLAPUR DISTRICT CENTRAL CO-OPERATIVE BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "245",
    Name: "South Indian Bank",
    Type: "Scheduled Commercial Banks",
    "Intrest Rate(%)": "9",
  },
  {
    number: "246",
    Name: "STATE BANK OF INDIA",
    Type: "Scheduled Commercial Banks",
    "Intrest Rate(%)": "9",
  },
  {
    number: "247",
    Name: "SULTANPUR JILLA SAHKARI BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "248",
    Name: "SURAT DISTRICT CO-OPERATIVE BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "249",
    Name: "Tamil Nadu Grama Bank",
    Type: "Regional Rural Banks",
    "Intrest Rate(%)": "9",
  },
  {
    number: "250",
    Name: "Tamilnad Mercantile Bank Ltd",
    Type: "Scheduled Commercial Banks",
    "Intrest Rate(%)": "9",
  },
  {
    number: "251",
    Name: "Tamluk Ghatal Central Co-Operative Bank Limited",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "252",
    Name: "TEHRI GARHWAL ZILA SAHKARI BANK LTD., TEHRI",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "253",
    Name: "Telangana Grameen Bank",
    Type: "Regional Rural Banks",
    "Intrest Rate(%)": "9",
  },
  {
    number: "254",
    Name: "THE  CENTRAL CO-OPERATIVE BANK LTD, BHILWARA",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "255",
    Name: "THE ADILABAD DISTRICT CO OPERATIVE CENTRAL  BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "256",
    Name: "THE AHMEDABAD DISTRICT CO-OPERATIVE BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "257",
    Name: "THE AHMEDNAGAR DISTRICT CENTRAL CO-OPERATIVE BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "258",
    Name: "THE AKOLA JANATA COMMERCIAL CO-OPERATIVE BANK LTD., AKOLA",
    Type: "Multi State Scheduled Cooperative Banks",
    "Intrest Rate(%)": "9",
  },
  {
    number: "259",
    Name: "THE ALWAR CENTRAL CO-OPERATIVE BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "260",
    Name: "THE AMBALA CENTRAL CO-OPERATIVE BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "261",
    Name: "THE AMRELI JILL MADHYASTHA SAHAKARI BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "3",
  },
  {
    number: "262",
    Name: "THE AMRITSAR CENTRAL CO-OPERATIVE BANK LTD., AMRITSAR",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "263",
    Name: "THE ANANTNAG CENTRAL CO-OPERATIVE BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "264",
    Name: "THE ANANTPUR DISTRICT CO OPERATIVE CENTRAL  BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "265",
    Name: "THE ANDHRA PRADESH STATE CO-OPERATIVE BANK LTD.",
    Type: "State Cooperative Banks",
    "Intrest Rate(%)": "4",
  },
  {
    number: "266",
    Name: "THE ANGUL UNITED  CENTRAL CO-OPERATIVE BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "267",
    Name: "THE ASKA CENTRAL CO-OPERATIVE BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "268",
    Name: "The Assam Cooperative Apex Bank Ltd",
    Type: "State Cooperative Banks",
    "Intrest Rate(%)": "4",
  },
  {
    number: "269",
    Name: "THE AURANGABAD DISTRICT CENTRAL CO-OPERATIVE BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "270",
    Name: "THE BALASORE BHADRAK CENTRAL CO-OPERATIVE BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "271",
    Name: "THE BANGLORE, BANGLORE RURAL & RAMANAGRA DISTRICT  CO-OPERATIVE BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "272",
    Name: "THE BANKI CENTRAL CO-OPERATIVE BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "273",
    Name: "THE BANSWARA CENTRAL CO-OPERATIVE BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "274",
    Name: "THE BARMER CENTRAL CO-OPERATIVE BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "275",
    Name: "THE BARODA CENTRAL CO-OPERATIVE BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "276",
    Name: "THE BEGUSARAI  CENTRAL CO-OPERATIVE BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "277",
    Name: "THE BELAGAVI DISTRICT CENTRAL CO-OPERATIVE BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "278",
    Name: "THE BELLARY DISTRICT  CO-OPERATIVE CENTRAL BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "279",
    Name: "THE BERHAMPORE CO-OPERATIVE CENTRAL .BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "280",
    Name: "THE BHAGALPUR  CENTRAL CO-OPERATIVE BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "281",
    Name: "THE BHARATPUR CENTRAL CO-OPERATIVE BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "282",
    Name: "THE BHARUCH DISTRICT CENTRAL CO-OPERATIVE BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "283",
    Name: "THE BHATINDA CENTRAL CO-OPERATIVE BANK LTD., BHATINDA",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "284",
    Name: "THE BHAWANIPATNA CENTRAL CO-OPERATIVE BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "285",
    Name: "THE BHIWANI CENTRAL CO-OPERATIVE BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "286",
    Name: "THE BIHAR STATE CO-OPERATIVE BANK LTD.",
    Type: "State Cooperative Banks",
    "Intrest Rate(%)": "4",
  },
  {
    number: "287",
    Name: "THE BOLANGIR DISTRICT CENTRAL CO-OPERATIVE BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "288",
    Name: "THE BOUDH CO-OPERATIVE CENTRAL BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "289",
    Name: "THE BUNDI DISTRICT CENTRAL CO-OPERATIVE BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "290",
    Name: "THE BURDWAN DISTRICT CENTRAL CO-OPERATIVE BANK LTD",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "291",
    Name: "THE CENTRAL CO-OPERATIVE  BANK LTD., BIKANER",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "292",
    Name: "THE CENTRAL CO-OPERATIVE BANK LTD.,TONK",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "293",
    Name: "THE CHHATTISGARH RAJYA SAHAKARI BANK MARYADIT",
    Type: "State Cooperative Banks",
    "Intrest Rate(%)": "4",
  },
  {
    number: "294",
    Name: "THE CHIKMAGALUR DISTRICT CO-OPERATIVE CENTRAL BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "295",
    Name: "THE CHITRADURGA DISTRICT CO-OPERATIVE CENTRAL BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "296",
    Name: "THE CHITTOOR DISTRICT CO-OPERATIVE CENTRAL BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "297",
    Name: "THE CHURU CENTRAL CO-OPERATIVE BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "298",
    Name: "THE COIMBATORE DISTRICT CENTRAL CO-OPERATIVE BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "299",
    Name: "THE CUDDALORE DISTRICT CENTRAL CO-OPERATIVE BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "300",
    Name: "THE DAKSHIN DINAJPUR DISTRICT CENTRAL CO-OPERATIVE BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "301",
    Name: "THE DAWANGERE DISTRICT CENTRAL CO-OPERATIVE BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "302",
    Name: "THE DHANBAD CENTRAL CO-OPERATIVE BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "303",
    Name: "THE DHARMAPURI DISTRICT CENTRAL CO-OPERATIVE BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "304",
    Name: "THE DISTRICT CO-OPERATIVE CENTRAL BANK LTD., BIDAR",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "305",
    Name: "THE DISTRICT CO-OPERATIVE CENTRAL BANK LTD., ELURU",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "306",
    Name: "THE DISTRICT CO-OPERATIVE CENTRAL BANK LTD., KHAMMAM",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "307",
    Name: "THE DISTRICT CO-OPERATIVE CENTRAL BANK LTD., MEDAK",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "308",
    Name: "THE DISTRICT CO-OPERATIVE CENTRAL BANK LTD., SRIKAKULAM",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "309",
    Name: "THE DISTRICT CO-OPERATIVE CENTRAL BANK LTD., VISAKHAPATNAM",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "310",
    Name: "THE DISTRICT CO-OPERATIVE CENTRAL BANK LTD., VIZIANAGARAM",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "311",
    Name: "THE DISTRICT CO-OPERATIVE CENTRAL BANK LTD., WARANGAL",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "312",
    Name: "THE DISTRICT COOPERATIVE CENTRAL BANK LTD., KAKINADA",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "313",
    Name: "THE DISTRICT COOPERATIVE CENTRAL BANK LTD., KURNOOL",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "314",
    Name: "THE DUNGARPUR CENTRAL CO-OPERATIVE BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "315",
    Name: "THE ERODE DISTRICT CENTRAL CO-OPERATIVE BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "316",
    Name: "THE FARIDABAD CENTRAL CO-OPERATIVE BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "317",
    Name: "THE FARIDKOT CENTRAL CO-OPERATIVE BANK LTD., FARIDKOT",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "318",
    Name: "THE FATEHABAD CENTRAL CO-OPERATIVE BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "319",
    Name: "THE FATEHGARH SAHIB CENTRAL CO-OPERATIVE BANK LTD., SIRHIND",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "320",
    Name: "THE FAZILKA CENTRAL CO-OPERATIVE BANK LTD., FAZILKA",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "321",
    Name: "The Federal Bank Ltd",
    Type: "Scheduled Commercial Banks",
    "Intrest Rate(%)": "9",
  },
  {
    number: "322",
    Name: "THE FEROZEPUR CENTRAL CO-OPERATIVE BANK LTD., FEROZEPUR",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "323",
    Name: "THE GANGANAGAR KENDRIYA SAHAKARI BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "324",
    Name: "THE GOA STATE CO-OPERATIVE BANK LTD.",
    Type: "State Cooperative Banks",
    "Intrest Rate(%)": "4",
  },
  {
    number: "325",
    Name: "THE GONDIA DISTRICT CENTRAL CO-OPERATIVE BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "326",
    Name: "THE GOPALGANJ CENTRAL CO-OPERATIVE BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "327",
    Name: "THE GUJARAT STATE CO-OPERATIVE BANK LTD.",
    Type: "State Cooperative Banks",
    "Intrest Rate(%)": "4",
  },
  {
    number: "328",
    Name: "THE GULBARGA AND YADGIR DISTRICT CO-OPERATIVE CENTRAL BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "329",
    Name: "THE GUNTUR DISTRICT CO-OPERATIVE CENTRAL BANK",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "330",
    Name: "THE GURDASPUR CENTRAL CO-OPERATIVE BANK LTD., GURDASPUR",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "331",
    Name: "THE GURGAON CENTRAL CO-OPERATIVE BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "332",
    Name: "THE HARYANA STATE CO-OPERATIVE APEX BANK LTD.",
    Type: "State Cooperative Banks",
    "Intrest Rate(%)": "4",
  },
  {
    number: "333",
    Name: "THE HASSAN DISTRICT  CO-OPERATIVE CENTRAL BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "334",
    Name: "THE HIMACHAL PRADESH STATE CO-OPERATIVE BANK LTD.",
    Type: "State Cooperative Banks",
    "Intrest Rate(%)": "4",
  },
  {
    number: "335",
    Name: "THE HISSAR CENTRAL CO-OPERATIVE BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "336",
    Name: "THE HOSHIARPUR CENTRAL CO-OPERATIVE BANK LTD., HOSHIARPUR",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "337",
    Name: "THE HYDERABAD DISTRICT CO-OPERATIVE CENTRAL BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "338",
    Name: "THE JAIPUR CENTRAL CO-OPERATIVE BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "339",
    Name: "THE JAISALMER CENTRAL CO-OPERATIVE BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "340",
    Name: "THE JALANDHAR CENTRAL CO-OPERATIVE BANK LTD., JALANDHAR",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "341",
    Name: "THE JALGAON DISTRICT CENTRAL CO-OPERATIVE BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "342",
    Name: "The Jalgaon People's Co-op Bank Ltd",
    Type: "Multi State Scheduled Cooperative Banks",
    "Intrest Rate(%)": "9",
  },
  {
    number: "343",
    Name: "The Jalgaon Peoples Co-op. Bank Ltd.",
    Type: "Multi State Scheduled Cooperative Banks",
    "Intrest Rate(%)": "9",
  },
  {
    number: "344",
    Name: "THE JALORE CENTRAL CO-OPERATIVE BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "345",
    Name: "THE JALPAIGURI CENTRAL CO-OPERATIVE BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "346",
    Name: "THE JAMMU CENTRAL CO-OPERATIVE BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "347",
    Name: "THE JAMNAGAR DISTRICT CO-OPERATIVE BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "348",
    Name: "THE JHAJJAR CENTRAL CO-OPERATIVE BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "349",
    Name: "THE JHALAWAR KENDRIYA SAHAKARI BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "350",
    Name: "The Jharkhand State Cooperative Bank",
    Type: "State Cooperative Banks",
    "Intrest Rate(%)": "4",
  },
  {
    number: "351",
    Name: "THE JIND CENTRAL CO-OPERATIVE BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "352",
    Name: "THE JODHPUR CENTRAL CO-OPERATIVE BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "353",
    Name: "THE JUNAGADH JILL SAHAKARI BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "354",
    Name: "THE KACHCHH DISTRICT CENTRAL CO-OPERATIVE BANK",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "355",
    Name: "THE KADAPA DISTRICT CO OPERATIVE CENTRAL  BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "356",
    Name: "THE KAIRA DISTRICT CENTRAL CO-OPERATIVE BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "357",
    Name: "THE KAITHAL CENTRAL CO-OPERATIVE BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "358",
    Name: "The Kalupur Commercial Co - Operative Bank Ltd.",
    Type: "Multi State Scheduled Cooperative Banks",
    "Intrest Rate(%)": "8.25",
  },
  {
    number: "359",
    Name: "THE KANARA DISTRICT CENTRAL CO- OPERATIVE BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "360",
    Name: "THE KANCHEEPURAM  CENTRAL CO-OP.BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "361",
    Name: "THE KANGRA CENTRAL CO-OPERATIVE BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "362",
    Name: "THE KANYAKUMARI DISTRICT CENTRAL CO-OPERATIVE BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "363",
    Name: "THE KAPURTHALA CENTRAL CO-OPERATIVE BANK LTD., KAPURTHALA",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "364",
    Name: "THE KARIMNAGAR DISTRICT CO-OPERATIVE CENTRAL BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "365",
    Name: "THE KARNAL CENTRAL CO-OPERATIVE BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "366",
    Name: "THE KARNATAKA CENTRAL CO-OPERATIVE BANK LTD.,(DHARWAD)",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "367",
    Name: "THE KARNATAKA STATE CO-OPERATIVE APEX BANK LTD.",
    Type: "State Cooperative Banks",
    "Intrest Rate(%)": "4",
  },
  {
    number: "368",
    Name: "THE KATIHAR DISTRICT CENTRAL CO-OPERATIVE BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "369",
    Name: "THE KERALA STATE CO-OPERATIVE BANK LTD.",
    Type: "State Cooperative Banks",
    "Intrest Rate(%)": "4",
  },
  {
    number: "370",
    Name: "THE KHAGARIA DISTRICT CENTRAL CO-OPERATIVE BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "371",
    Name: "THE KHURDA CENTRAL CO-OPERATIVE BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "372",
    Name: "THE KODAGU DISTRICT  CO-OPERATIVE CENTRAL BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "373",
    Name: "THE KODINAR TALUKA CO-OPERATIVE BANKING UNION LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "374",
    Name: "THE KOLAR AND CHICKABALLAPUR DISTRICT CO OPERATIVE  CENTRAL BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "375",
    Name: "THE KOLAR AND CHICKABALLAPUR DISTRICT CO OPERATIVE  CENTRAL BANK LTD. (Kolar)",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "376",
    Name: "THE KORAPUT CENTRAL CO-OPERATIVE BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "377",
    Name: "THE KOTA CENTRAL CO-OPERATIVE BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "378",
    Name: "THE KRISHNA DISTRICT CO-OPERATIVE CENTRAL BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "379",
    Name: "THE KUMBAKONAM CENTRAL CO-OP BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "380",
    Name: "THE KURUKSHETRA CENTRAL CO-OPERATIVE BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "381",
    Name: "THE LUDHIANA CENTRAL CO-OPERATIVE BANK LTD., LUDHIANA",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "382",
    Name: "THE MADHYA PRADESH RAJYA SAHAKARI BANK MARYADIT",
    Type: "State Cooperative Banks",
    "Intrest Rate(%)": "4",
  },
  {
    number: "383",
    Name: "THE MADURAI DISTRICT CENTRAL CO-OPERATIVE BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "384",
    Name: "THE MAGADH CENTRAL CO-OPERATIVE BANK LTD., GAYA",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "385",
    Name: "THE MAHARASHTRA STATE CO-OPERATIVE BANK LTD.",
    Type: "State Cooperative Banks",
    "Intrest Rate(%)": "4",
  },
  {
    number: "386",
    Name: "THE MAHBUBNAGAR DISTRICT CO-OPERATIVE CENTRAL BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "387",
    Name: "THE MAHENDRAGARH CENTRAL CO-OPERATIVE BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "388",
    Name: "THE MALAPPURAM DISTRICT CO-OPERATIVE BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "389",
    Name: "THE MANSA CENTRAL CO-OPERATIVE BANK LTD., MANSA",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "390",
    Name: "THE MAYURBHANJ DISTRICT CENTRAL CO-OPERATIVE BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "391",
    Name: "THE MOGA CENTRAL CO-OPERATIVE BANK LTD., MOGA",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "392",
    Name: "THE MONGHYR-JAMUI CENTRAL CO-OPERATIVE BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "393",
    Name: "THE MOTIHARI CENTRAL CO-OPERATIVE BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "394",
    Name: "THE MUKTSAR CENTRAL CO-OPERATIVE BANK LTD., MUKTSAR",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "395",
    Name: "THE MUMBAI DISTRICT CENTRAL CO-OPERATIVE BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "396",
    Name: "THE MUZAFFARPUR CENTRAL CO-OPERATIVE  BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "397",
    Name: "THE MYSORE AND CHAMARAJNAGAR DISTRICT COOPERATIVE  CENTRAL BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "398",
    Name: "THE NAGAUR CENTRAL CO-OPERATIVE BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "399",
    Name: "THE NALANDA CENTRAL CO-OPERATIVE BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "400",
    Name: "THE NALGONDA DISTRICT CO-OPERATIVE CENTRAL BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "401",
    Name: "THE NANDED DISTRICT CENTRAL CO-OPERATIVE BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "402",
    Name: "THE NATIONAL CENTRAL CO-OPERATIVE BANK LTD., BETTIAH",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "403",
    Name: "THE NAWADAH CENTRAL CO-OPERATIVE BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "404",
    Name: "THE NAWANSHAHR CENTRAL CO-OPERATIVE BANK LTD., NAWANSHAHR",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "405",
    Name: "THE NELLORE DISTRICT CO-OPERATIVE CENTRAL BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "406",
    Name: "THE NILGIRIS DISTRICT CENTRAL CO-OPERATIVE BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "407",
    Name: "THE NIZAMABAD DISTRICT CO-OPERATIVE CENTRAL BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "408",
    Name: "THE ODISHA STATE CO-OPERATIVE BANK LTD.",
    Type: "State Cooperative Banks",
    "Intrest Rate(%)": "4",
  },
  {
    number: "409",
    Name: "THE PALI DISTRICT CENTRAL CO-OPERATIVE BANK LTD",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "410",
    Name: "THE PANCHAKULA  CENTAL CO-OPERATIVE BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "411",
    Name: "THE PANIPAT  CENTRAL CO-OPERATIVE BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "412",
    Name: "THE PATALIPUTRA CENTRAL CO-OPERATIVE BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "413",
    Name: "THE PATIALA CENTRAL CO-OPERATIVE BANK LTD., PATIALA",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "414",
    Name: "THE PONDICHERRY STATE CO-OPERATIVE BANK LTD.",
    Type: "State Cooperative Banks",
    "Intrest Rate(%)": "4",
  },
  {
    number: "415",
    Name: "THE PRAKASAM DISTRICT CO-OPERATIVE CENTRAL BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "416",
    Name: "THE PUDUKOTTAI DISTRICT CENTRAL CO-OPERATIVE BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "417",
    Name: "THE PUNJAB STATE CO-OPERATIVE BANK LTD.",
    Type: "State Cooperative Banks",
    "Intrest Rate(%)": "4",
  },
  {
    number: "418",
    Name: "THE PURNEA DISTRICT CENTRAL CO-OPERATIVE BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "419",
    Name: "THE RAICHUR DISTRICT CENTRAL CO-OPERATIVE BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "420",
    Name: "THE RAJASTHAN STATE CO-OPERATIVE BANK LTD.",
    Type: "State Cooperative Banks",
    "Intrest Rate(%)": "4",
  },
  {
    number: "421",
    Name: "THE RAMANATHAPURAM DISTRICT CENTRAL CO-OPERATIVE BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "422",
    Name: "THE REWARI CENTRAL CO-OPERATIVE BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "423",
    Name: "THE ROHIKA CENTRAL CO-OPERATIVE BANK LTD., MADHUBANI",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "424",
    Name: "THE ROHTAK CENTRAL CO-OPERATIVE BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "425",
    Name: "THE ROPAR CENTRAL CO-OPERATIVE BANK LTD., ROPAR",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "426",
    Name: "THE SALEM DISTRICT CENTRAL CO-OPERATIVE BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "427",
    Name: "THE SAMASTIPUR DISTRICT CENTRAL CO-OPERATIVE BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "428",
    Name: "THE SAMBALPUR DIST.CO-OPERATIVE CENTRAL BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "429",
    Name: "THE SANGRUR CENTRAL CO-OPERATIVE BANK LTD., SANGRUR",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "430",
    Name: "THE SAS NAGAR CENTRAL CO-OP. BANK LTD., SAS NAGAR",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "431",
    Name: "THE SATARA DISTRICT CENTRAL CO-OPERATIVE BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "432",
    Name: "THE SHIMOGA DISTRICT CO-OPERATIVE CENTRAL BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "433",
    Name: "THE SIKAR KENDRIYA SAHAKARI BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "434",
    Name: "THE SIROHI CENTRAL CO-OPERATIVE BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "435",
    Name: "THE SIRSA CENTRAL CO-OPERATIVE BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "436",
    Name: "THE SITAMARHI CENTRAL CO-OPERATIVE BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "437",
    Name: "THE SIVGANGAI DISTRICT CENTRAL CO-OPERATIVE BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "438",
    Name: "THE SIWAN CENTRAL CO-OPERATIVE BANK LTD., SIWAN",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "439",
    Name: "THE SONEPAT CENTRAL CO-OPERATIVE BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "440",
    Name: "THE SOUTH CANARA DISTRICT CENTRAL CO-OPERATIVE BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "441",
    Name: "THE SUNDARGARH DISTRICT CENTRAL CO-OPERATIVE BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "442",
    Name: "THE SURENDRANAGAR DISTRICT CO-OPERATIVE BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "443",
    Name: "THE TAMIL NADU STATE APEX CO-OPERATIVE BANK LTD.",
    Type: "State Cooperative Banks",
    "Intrest Rate(%)": "4",
  },
  {
    number: "444",
    Name: "THE TARAN TARAN CENTRAL CO-OPERATIVE BANK LTD., TARAN TARAN",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "445",
    Name: "THE TELANGANA STATE CO-OPERATIVE BANK LTD.",
    Type: "State Cooperative Banks",
    "Intrest Rate(%)": "4",
  },
  {
    number: "446",
    Name: "THE THANE DISTRICT CENTRAL CO-OPERATIVE BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "447",
    Name: "THE THANJAVUR CENTRAL CO-OPERATIVE BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "448",
    Name: "THE TIRUCHIRAPALLI DISTRICT CENTRAL CO-OPERATIVE BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "449",
    Name: "THE TIRUNELVELI DISTRICT CENTRAL CO-OPERATIVE BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "450",
    Name: "THE TIRUVANNAMALAI DISTRICT CENTRAL CO-OPERATIVE BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "451",
    Name: "THE TUMKUR DISTRICT CENTRAL CO-OPERATIVE BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "452",
    Name: "THE UDAIPUR CENTRAL CO-OPERATIVE BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "453",
    Name: "THE UNITED PURI-NIMAPARA CENTRAL COOPERATIVE BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "454",
    Name: "THE UTTAR PRADESH STATE CO-OPERATIVE BANK LTD.",
    Type: "State Cooperative Banks",
    "Intrest Rate(%)": "4",
  },
  {
    number: "455",
    Name: "THE UTTARAKHAND STATE CO-OPERATIVE BANK LTD.",
    Type: "State Cooperative Banks",
    "Intrest Rate(%)": "4",
  },
  {
    number: "456",
    Name: "THE UTTARKASHI ZILA SAHKARI BANK LTD., UTTARKASHI",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "457",
    Name: "THE VAISHALI DISTRICT CENTRAL CO-OPERATIVE BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "458",
    Name: "THE VELLORE DISTRICT CENTRAL COOPERATIVE BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "459",
    Name: "THE VIJAYAPURA DISTRICT CENTRAL CO-OPERATIVE BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "460",
    Name: "THE VILLUPURAM DISTRICT CENTRAL CO-OPERATIVE BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "461",
    Name: "THE VIRUDHUNAGAR DISTRICT CENTRAL CO-OPERATIVE BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "462",
    Name: "THE WEST BENGAL STATE CO-OPERATIVE BANK LTD.",
    Type: "State Cooperative Banks",
    "Intrest Rate(%)": "4",
  },
  {
    number: "463",
    Name: "THE YAMUNANAGAR CENTRAL CO-OPERATIVE  BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "464",
    Name: "THOOTHUKUDI DISTRICT CENTRAL CO-OPERATIVE BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "465",
    Name: "TJSB Sahakari Bank Limited",
    Type: "Multi State Scheduled Cooperative Banks",
    "Intrest Rate(%)": "9",
  },
  {
    number: "466",
    Name: "Tripura Gramin Bank",
    Type: "Regional Rural Banks",
    "Intrest Rate(%)": "9",
  },
  {
    number: "467",
    Name: "Tripura State Cooperative Bank Ltd.",
    Type: "State Cooperative Banks",
    "Intrest Rate(%)": "4",
  },
  {
    number: "468",
    Name: "UCO Bank",
    Type: "Scheduled Commercial Banks",
    "Intrest Rate(%)": "9",
  },
  {
    number: "469",
    Name: "UDHAMSINGHNAGAR DISTRICT COOPERATIVE BANK LTD., RUDRAPUR",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "470",
    Name: "Union Bank of India",
    Type: "Scheduled Commercial Banks",
    "Intrest Rate(%)": "9",
  },
  {
    number: "471",
    Name: "Utkal Grameen Bank",
    Type: "Regional Rural Banks",
    "Intrest Rate(%)": "9",
  },
  {
    number: "472",
    Name: "Uttar Bihar Gramin Bank",
    Type: "Regional Rural Banks",
    "Intrest Rate(%)": "9",
  },
  {
    number: "473",
    Name: "Uttarakhand Gramin Bank",
    Type: "Regional Rural Banks",
    "Intrest Rate(%)": "9",
  },
  {
    number: "474",
    Name: "Uttarbanga Kshetriya Gramin Bank",
    Type: "Regional Rural Banks",
    "Intrest Rate(%)": "9",
  },
  {
    number: "475",
    Name: "VALSAD DISTRICT CENTRAL CO-OPERATIVE BANK LTD",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "476",
    Name: "Vidharbha Konkan Gramin Bank",
    Type: "Regional Rural Banks",
    "Intrest Rate(%)": "9",
  },
  {
    number: "477",
    Name: "VIDYASAGAR CENTRAL CO-OPERATIVE BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "478",
    Name: "WARDHA DISTRICT CENTRAL CO-OPERATIVE BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "479",
    Name: "YAVATMAL DISTRICT CENTRAL CO-OPERATIVE BANK LTD.",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "480",
    Name: "YES BANK LTD",
    Type: "Scheduled Commercial Banks",
    "Intrest Rate(%)": "9",
  },
  {
    number: "481",
    Name: "ZILA SAHKARI BANK LTD., GARHWAL (KOTDWAR)",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
  {
    number: "482",
    Name: "ZILA SAHKARI BANK LTD., HARIDWAR",
    Type: "DCCBs with PACS affiliation",
    "Intrest Rate(%)": "4",
  },
];
